export const LOCATION_FIELDS = [
  'addressLine1',
  'addressLine2',
  'city',
  'state',
  'zipCode',
  'country',
];
